export const SimpleFormIteratorPrefix = 'RaSimpleFormIterator';

export const SimpleFormIteratorClasses = {
    action: `${SimpleFormIteratorPrefix}-action`,
    add: `${SimpleFormIteratorPrefix}-add`,
    clear: `${SimpleFormIteratorPrefix}-clear`,
    form: `${SimpleFormIteratorPrefix}-form`,
    index: `${SimpleFormIteratorPrefix}-index`,
    inline: `${SimpleFormIteratorPrefix}-inline`,
    line: `${SimpleFormIteratorPrefix}-line`,
    list: `${SimpleFormIteratorPrefix}-list`,
    buttons: `${SimpleFormIteratorPrefix}-buttons`,
};
